const routes = [
  {
    path: 'calls_and_texting/settings',
    component: () => import(/* webpackChunkName: "CallsTextingSettings" */ './views/CallsTextingSettings.vue'),
    name: 'callsTextingSettings',
    props: (route) => ({ ...route.query, ...route.params }),
    meta: { pageNameEn: 'Calls and Texting Settings' },
  },
];

export default routes;
